import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import OrderForm from "./OrderForm";
import { PhoneCall, ShieldCheck, Timer } from "lucide-react";
import PhoneHours, { trackCall } from "./PhoneHours";

export default function ContactSection() {
  const { t } = useLang();
  return (
    <section id="contatti" className="py-20 lg:py-28" data-testid="contact-section">
      <div className="max-w-6xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("contact.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("contact.title")}</h2>
          <p className="mt-4 text-base text-[#64748B]">{t("contact.sub")}</p>
          <a data-testid="contact-call-btn" href="tel:+393713142397"
            onClick={() => trackCall("contact_section")}
            className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-[#003087] text-white px-6 py-4 shadow-lg shadow-[#003087]/20 hover:bg-[#00AEEF] transition-colors duration-200">
            <span className="w-10 h-10 rounded-xl bg-white/15 flex items-center justify-center">
              <PhoneCall size={18} />
            </span>
            <span className="text-left">
              <span className="block text-[11px] font-semibold uppercase tracking-wider text-[#9BDDF7]">{t("contact.call")}</span>
              <span className="block text-xl font-bold leading-tight">371 314 2397</span>
            </span>
          </a>
          <PhoneHours className="mt-2.5 ml-1" />
          <div className="mt-8 space-y-4">
            {[
              [Timer, "Risposta entro 2 ore lavorative"],
              [ShieldCheck, "Dati protetti e conformi GDPR"],
              [PhoneCall, "Consulente dedicato, mai un call center"],
            ].map(([Icon, txt], i) => (
              <div key={i} className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-xl bg-[#E6F6FD] flex items-center justify-center">
                  <Icon size={17} className="text-[#00AEEF]" />
                </span>
                <span className="text-sm font-semibold text-[#003087]">{txt}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: 0.15 }}
          className="card rounded-3xl p-7 sm:p-9" data-testid="contact-form-card">
          <OrderForm dual testidPrefix="contact" />
        </motion.div>
      </div>
    </section>
  );
}
